module.exports = __webpack_public_path__ + "img/gold1.b9324834.png";